import { render, staticRenderFns } from "./customsInfo.vue?vue&type=template&id=0783aadb&scoped=true&"
import script from "./customsInfo.vue?vue&type=script&lang=js&"
export * from "./customsInfo.vue?vue&type=script&lang=js&"
import style0 from "./customsInfo.vue?vue&type=style&index=0&id=0783aadb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0783aadb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0783aadb')) {
      api.createRecord('0783aadb', component.options)
    } else {
      api.reload('0783aadb', component.options)
    }
    module.hot.accept("./customsInfo.vue?vue&type=template&id=0783aadb&scoped=true&", function () {
      api.rerender('0783aadb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/customsInfo.vue"
export default component.exports